import { INLINE_MARKDOWN_REGEX } from "../utils/inlineMarkdownRegex";

/**
 * Strips inline markdown syntax from a string, returning plain text.
 * Intended for accessibility contexts (e.g. `aria-label`) where only plain text is appropriate.
 *
 * @param str - The string to strip
 * @returns The string with all inline markdown syntax removed
 */
export const stripInlineMarkdown = (str: string): string => {
  const parts: string[] = [];
  let lastIndex = 0;

  INLINE_MARKDOWN_REGEX.lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = INLINE_MARKDOWN_REGEX.exec(str)) !== null) {
    if (match.index > lastIndex) {
      parts.push(str.substring(lastIndex, match.index));
    }

    const savedIndex = INLINE_MARKDOWN_REGEX.lastIndex;
    const inner =
      match[1] ?? match[2] ?? match[3] ?? match[4] ?? match[5] ?? "";

    // code spans don't support nested markdown, matching parseInlineMarkdown behavior
    parts.push(match[5] ? inner : stripInlineMarkdown(inner));

    INLINE_MARKDOWN_REGEX.lastIndex = savedIndex;
    lastIndex = savedIndex;
  }

  if (lastIndex < str.length) {
    parts.push(str.substring(lastIndex));
  }

  return parts.join("");
};
